export default __webpack_public_path__ + "images/c7a4b1ab5b02b39d8c65f8e52a026ed1-gasStatusBar.png";